__turbopack_context__.v({
  "lockIcon": "logInButton-module-scss-module__Jr0TAG__lockIcon",
  "loginButton": "logInButton-module-scss-module__Jr0TAG__loginButton",
});
